import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar, X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function FloatingBookButton() {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  // Don't show on book page
  if (location.pathname === '/book') {
    return null;
  }

  return (
    <>
      {/* Floating Button - All Screens */}
      <motion.button
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ 
          type: "spring",
          stiffness: 260,
          damping: 20,
          delay: 1
        }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setShowModal(true)}
        className="fixed bottom-6 left-6 z-40 w-16 h-16 rounded-full bg-gradient-to-br from-primary to-charcoal text-white shadow-2xl flex items-center justify-center group"
        aria-label={t('booking.floatingOpen')}
        data-testid="floating-book-btn"
      >
        <Calendar className="w-7 h-7 group-hover:scale-110 transition-transform" />
      </motion.button>

      {/* Modal Overlay */}
      <AnimatePresence>
        {showModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-charcoal/80 backdrop-blur-sm"
            onClick={() => setShowModal(false)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
              className="relative w-full h-full max-w-2xl max-h-[90vh] m-4 bg-warm-white rounded-3xl shadow-2xl overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center hover:bg-white transition-colors shadow-lg"
                aria-label={t('booking.floatingClose')}
                data-testid="close-modal-btn"
              >
                <X className="w-5 h-5 text-charcoal" />
              </button>

              {/* Modal Header */}
              <div className="bg-gradient-to-r from-primary to-accent p-6 pb-8">
                <h2 className="font-playfair text-3xl font-medium text-white text-center" data-testid="floating-modal-title">
                  {t('booking.floatingTitle')}
                </h2>
                <p className="text-white/90 text-center mt-2">
                  {t('booking.floatingSubtitle')}
                </p>
              </div>

              {/* MoeGo Iframe */}
              <div className="relative h-[calc(100%-120px)]">
                <iframe
                  src="https://booking.moego.pet/ol/CasaPooch/book?utm_medium=embed"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  title={t('booking.iframeTitle')}
                  scrolling="yes"
                  className="w-full h-full"
                ></iframe>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default FloatingBookButton;